const initState = () => ({
})

export const state = initState

export const getters = {
}

export const mutations = {

}

export const actions = {
  async getEmailTemplatesByEmailCode({}, emailCode){
    let emails = []

    try{
      const result = await this.$axios.$get(`/webpos/email/${emailCode}/templates`);
      if(result && result?.apiMessages?.hasErrors === false){
        emails = result.value
      }
      else{
        this.$toast.error('Error while retrieving email templates');
      }
    }
    catch{
      this.$toast.error('Error while retrieving email templates');
    }
    return emails;
  },

  async getAutoEmailByCode({}, emailCode) {
    let emailTemplate = null;

    try {
      const result = await this.$axios.$get(`/webpos/email/${emailCode}/template`);
      if (result && result?.apiMessages?.hasErrors === false) {
        emailTemplate = result.value;
      } else {
        this.$toast.error('Error while retrieving email template');
      }
    } catch {
      this.$toast.error('Error while retrieving email template');
    }

    return emailTemplate;
  },

  async getEmailPreview({commit, state}, emailData) {
    let email = null
    try{
      const result = await this.$axios.$get(`/webpos/email/preview?${new URLSearchParams(emailData).toString()}`, emailData);
      if(!result || result.hasErrors){
        this.$toast.error('Error while generating email preview');
      }
      else{
        email = result.value;
        if(!result.value.reportParameterIsValid){
          this.$toast.show('We couldn\'t generate the attachment as there’s no related document in the system yet')
        }
      }
    }
    catch{
      this.$toast.error('Error while generating email preview');
    }
    return email;
  },

  async sendEmail({commit, state}, emailPreview) {
    try{
      const result = await this.$axios.$post(`/webpos/email/send`, emailPreview);
      if(result && !result.hasErrors){
        this.$toast.success('Email sent successfully');
        return true;
      }
      else{
        if(result && result.errorMessages && result.errorMessages.length > 0){
          this.$toast.error(result.errorMessages[0].value);
        }
        else{
          this.$toast.error('Error while sending email');
        }
      }
    }
    catch{
      this.$toast.error('Error while sending email');
    }
    return false;
  },

  async sendEmailInstantly({commit, state}, emailData) {
    try{
      const result = await this.$axios.$post(`/webpos/email/send-instantly`, emailData);
      if(result && !result.hasErrors){
        this.$toast.success('Email sent successfully');
        return true;
      }
      else{
        if(result && result.errorMessages && result.errorMessages.length > 0){
          this.$toast.error(result.errorMessages[0].value);
        }
        else{
          this.$toast.error('Error while sending email');
        }
      }
    }
    catch{
      this.$toast.error('Error while sending email');
    }
    return false;
  },

  async getEmailAttachments({commit, state}, emailQueueID){
    let attachments = []
    try{
      const result = await this.$axios.$get(`/webpos/email/attachments?emailQueueID=${emailQueueID}`);
      if (result && !result.apiMessages.hasErrors) {
        attachments = result.value;
      }
      else{
        this.$toast.error("Error while getting customer email");
      }
    }
    catch(e){
      this.$toast.error('Error while getting attachments');
    }
    return attachments;
  }
}
